import {
	Table, Pagination, Col, Row, Select, Tree
}from 'antd'
import {
	useEffect,
	useState
}from 'react'
import {
	useSelector, useDispatch
}from 'react-redux'
import CustomInput from "../../../components/CustomInput"
import CustomSelect from "../../../components/CustomSelect"
import {
	reConstructionMaterialActions
}from './store/actions'
import {
	reConstructionCategoryActions
}from "../ReConstructionCategory/store/actions"
import {
	useDebounce
}from 'use-debounce'
import './style.css'
import LocalLoading from '../../../components/Loading/Local'
import axios from 'axios'

const ReConstructionMaterial = (props) => {
	const { withHeader = false } = props
	const [treeData, setTreeData] = useState([])
	const [selectCategory, setSelectCategory] = useState(null)
	const { paged, isSending } = useSelector(state => state.reConstructionMaterialReducer)
	const { list: categories, find: foundCategories } = useSelector(state => state.reConstructionCategoryReducer)
	const [searchCategory, setSearchCategory] = useState('')
	const [chooseCategory, setChooseCategory] = useState(null)
	const [category] = useDebounce(searchCategory, 500)
	const [selectedKeys, setSelectedKeys] = useState([])
	const [expandedKeys, setExpandedKeys] = useState([])
	const [loadedKeys, setLoadedKeys] = useState([])
	const [filter, setFilter] = useState({
		page     : 1,
		pageSize : 10,
		category : null,
		material : ""
	})
	const [searchFilter] = useDebounce(filter, 200)
	const [table, setTable] = useState([])
	const [count, setCount] = useState(0)

	const dispatch = useDispatch()
	const pageSize = 10

	const onPaginationChange = (value) => {
		setFilter({ ...filter,
			page: value })
	}

	useEffect(() => {
		return () => {
			dispatch(reConstructionMaterialActions.clear())
			dispatch(reConstructionCategoryActions.clear())
			setFilter({ page     : 1,
				pageSize : 10,
				category : null,
				material : "" })
			setExpandedKeys([])
			setSelectedKeys([])
		}
	}, [])

	useEffect(() => {
		if (filter.category)
			getMaterials(filter)
	}, [searchFilter])

	useEffect(() => {
		if (category.length > 0){
			getCategoriesByName({
				name     : category,
				pageSize : pageSize
			})
		}
	}, [category])

	useEffect(() => {
		findCategory({
			category : selectCategory,
			isActual : true
		})
	}, [selectCategory])

	useEffect(() => {
		function mapNode(items){
			return items.map((item => ({
				title    : `${ item.codeKKM } ${ item.name }`,
				key      : item.id,
				isLeaf   : item.isLeaf,
				isAny    : item.isAnyMaterial,
				children : item.children?.length ? mapNode(item.children) : null
			})))
		}
		if (foundCategories){
			setTreeData(mapNode(foundCategories.tree))
			if (foundCategories.selected){
				setSelectedKeys([foundCategories.selected])
				setFilter({ ...filter,
					material : "",
					page     : 1,
					category : foundCategories.selected })
				setChooseCategory(foundCategories.selectedName)
			}
			setLoadedKeys([])
			setExpandedKeys(foundCategories.expanded)
		}
	}, [foundCategories])

	const getMaterials = (values) => {
		dispatch(reConstructionMaterialActions.getPaged(values))
	}

	const findCategory = (values) => {
		dispatch(reConstructionCategoryActions.find(values))
	}

	const getCategoriesByName = (values) => {
		dispatch(reConstructionCategoryActions.getList(values))
	}

	const updateTreeData = (list, key, children) => list.map((node) => {
		if (node.key === key){
			return { ...node,
				children }
		}
		if (node.children){
			return {
				...node,
				children: updateTreeData(node.children, key, children)
			}
		}
		return node
	})

	useEffect(() => {
		if (paged?.items){
			setCount(paged.count)
			setTable(paged.items)
		}
	}, [paged])

	const onLoadData = ({ key, children }) => new Promise((resolve) => {
		if (children){
			resolve()
			return
		}
		setLoadedKeys(loadedKeys.concat([key]))
		axios.get("/ReConstructionCategory/getChilds", {
			params: {
				isActual : true,
				parent   : key
			}
		}).then(res => res.data)
			.then(data => {
				setTreeData((origin) => updateTreeData(origin, key, data.map(item => ({
					title  : `${ item.codeKKM } ${ item.name }`,
					key    : item.id,
					isLeaf : item.isLeaf,
					isAny  : item.isAnyMaterial
				}))))
				resolve()
			})
	})

	function onSelectCategory(keys, info){
		setSelectedKeys(keys)
		if (info.selected && info.node.isAny){
			setChooseCategory(info.node.title)
			setFilter({ ...filter,
				category : info.node.key,
				page     : 1,
				material : "" })
		}
	}

	const columns = [
		{
			dataIndex : 'codeKKM',
			inputType : 'text',
			key       : 'codeKKM',
			title     : 'Код по каталогу-классификатору',
			width     : '20%'
		},
		{
			dataIndex : 'code',
			inputType : 'text',
			key       : 'code',
			title     : 'Код по сборникам сметных цен',
			width     : '15%'
		},
		{
			dataIndex : 'name',
			inputType : 'text',
			key       : 'name',
			title     : 'Название строительного материала',
			width     : '50%'
		},
		{
			dataIndex : 'measureUnitName',
			inputType : 'text',
			key       : 'measureUnitName',
			title     : 'Единица измерения',
			width     : '15%'
		}

		// {
		// 	dataIndex : 'pricing',
		// 	inputType : 'text',
		// 	key       : 'pricing',
		// 	title     : 'Расценки',
		// 	width     : '15%'
		// }
	]

	return (
		<div className={ `${ withHeader ? "all-catalog" : "" }` }>
			{
				withHeader && (
					<h1 className="catalog-header">
						Каталог-классификатор
					</h1>
				)
			}
			<Row id="construction-category">
				<Col span={ withHeader ? 10 : 6 }>
					<div style={ { maxWidth: "97%" } }>
						<CustomSelect
							allowClear
							showSearch
							className="filter-category"
							filterOption={ false }
							mode="single"
							notFoundContent={ null }
							placeholder="Введите категорию строительного материала"
							onChange={ (value) => value && setSelectCategory(value) }
							onSearch={ (value) => setSearchCategory(value) }
						>
							{ categories?.map(item => {
								return (
									<Select.Option
										key={ item.id }
										title={ `${ item.codeKKM } ${ item.name }` }
										value={ item.id }
									>
										{ `${ item.codeKKM } ${ item.name }` }
									</Select.Option>)
							}) }
						</CustomSelect>
						<Tree
							expandedKeys={ expandedKeys }
							height={ 850 }
							loadData={ onLoadData }
							loadedKeys={ loadedKeys }
							selectedKeys={ selectedKeys }
							treeData={ treeData }
							onExpand={ (keys) => setExpandedKeys(keys) }
							onSelect={ (keys, info) => onSelectCategory(keys, info) }
						/>
					</div>
				</Col>
				<Col span={ withHeader ? 14 : 18 }>
					{ Boolean(chooseCategory) && (
						<>
							<h2>
								{ chooseCategory }
							</h2>
							<CustomInput
								placeholder="Введите название/код строительного материала"
								value={ filter.material }
								onChange={ (e) => setFilter({ ...filter,
									material : e.target.value,
									page     : 1 }) }
							/>
							<Table
								className={ `${ withHeader ? "catalog-table" : "" }` }
								columns={ columns }
								dataSource={ table }
								loading={ { indicator : <LocalLoading />,
									spinning  : isSending } }
								pagination={ false }
								scroll={ { x: 700 } }
							/>
							{ count > pageSize
								? (
									<Pagination
										showQuickJumper
										className={ `${ withHeader ? "catalog-pagination" : "" }` }
										current={ filter.page }
										pageSize={ filter.pageSize }
										showSizeChanger={ false }
										size="small"
										total={ count }
										onChange={ onPaginationChange }
									/>)
								: null }
						</>
					) }
				</Col>
			</Row>

			{ /* <ModalActuallCategory
				hierarchyList={ hierarchyList }
				materialId={ materialId }
				pageSize={ pageSize }
				setVisible={ setVisiibleCategoryModal }
				visible={ visiibleCategoryModal }
			/> */ }
		</div>
	)
}

export default ReConstructionMaterial